import React from 'react';
import { CmhcIcon, CmhcIconSize } from '@cmhc-schl/hearth-ui';
import { Box, Stack, Typography, IconButton } from '@mui/material';
import { LoanInventoryTableFields } from '../../HbtPortfolioLoansInventoryTable/types';
import styles from '../styles.module.scss';

type HeaderProps = {
  count: number;
  subHeaderText: string;
  bodyContent: string;
  selectedRowSubHeaderData: string;
  handleCloseFlyout: () => void;
  t: (key: string) => string;
  data: LoanInventoryTableFields[];
};

const RightPaneHeader: React.FC<HeaderProps> = ({
  count,
  subHeaderText,
  bodyContent,
  selectedRowSubHeaderData,
  handleCloseFlyout,
  t,
  data
}) => {
  return (
    <Box>
      <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
        <Box sx={{ flexGrow: 1 }}>
          <Box className={`${styles.header} ${count === 0 ? styles.subHeader : ''}`}>
            {t('PI-Portfolio-Management-Loans-Details-Header')}
          </Box>
          {count > 0 && (
            <Box className={styles.subHeader}>
              {count > 1
                ? `(${count}) ${t('PI-Portfolio-Management-Loans-Details-Selected')}`
                : `${subHeaderText} ${selectedRowSubHeaderData || ''}`}
            </Box>
          )}
          <Typography>{bodyContent}</Typography>
        </Box>

        <Stack direction="row" spacing={1} alignItems="flex-start">
          <IconButton
            disableRipple
            aria-label={t('PI-Portfolio-Management-Loans-Close-Flyout')}
            onClick={handleCloseFlyout}
          >
            <CmhcIcon size={CmhcIconSize.MEDIUM} type="icon_close" className={styles.icon} />
          </IconButton>
        </Stack>
      </Stack>
    </Box>
  );
};

export default RightPaneHeader;
